import { Location } from "react-router-dom";

export const isCurrentPath = (path: string, location: Location<any>) => {
  if (path === "") return false;
  return location.pathname.startsWith(path);
};

export function getUrlPathId(url: string) {
  const parts = url.split("/");
  return parts[parts.length - 1];
}

